export enum ImportOrderAnalyticsMessages {
  capability = 'orders',
  importFileEvent = 'import file',
  importOrderModalEvent = 'modal open',
  modalName = 'import order',
  fileType = 'import:order:',
}
